import * as ents from '@attain-apps/entities'
import type * as chartJs from 'chart.js'

import * as colors from '../../../colors'
import * as utils from '../utils'

/**
 * Transform data from
 * {@link ents.core.display.chart.data.Of<ents.core.display.chart.Type.LineChart>} to
 * {@link chartJs.ChartData<'line'>}
 */
export function getData(
  data: ents.core.display.chart.data.Of<ents.core.display.chart.Type.Line>,
): chartJs.ChartData<'line'> {
  // TODO: support multiple graphs in one widget

  let { values } = data
  const palette = colors.createPalette(ents.core.display.chart.Type.Line)
  // If x values are numerical, we should sort it from lowest to largest, so it
  // can be displayed properly in chart
  if (utils.hasNumericXValues(values)) {
    values = values?.map(value => ({
      ...value,
      points:
        value.points &&
        [...value.points].sort(
          (a, b) =>
            (typeof a.x == 'number' ? a.x : 0) -
            (typeof b.x == 'number' ? b.x : 0),
        ),
    }))
  }

  // Extract unique labels across all datasets to avoid duplicates
  const xValues =
    values?.flatMap(value => value.points?.map(point => point.x ?? 0)) ?? []
  const labels = [...new Set(xValues)]

  // Sort labels if they are numeric
  if (utils.hasNumericXValues(values)) {
    labels.sort(
      (a, b) =>
        (typeof a === 'number' ? a : 0) - (typeof b === 'number' ? b : 0),
    )
  }

  const datasets: chartJs.ChartDataset<'line'>[] =
    values?.map(({ color: _color, name, points }, i) => {
      const datasetColor =
        _color ?? palette.getOrAssignColorFor(name ?? i.toString())
      return {
        backgroundColor: datasetColor,
        borderColor: datasetColor,
        data: points?.map(point => point.y ?? 0) ?? [],
        label: name,
      }
    }) ?? []

  return {
    datasets,
    labels,
  }
}
